<template>
  <el-dialog
    title="编辑名片"
    :visible.sync="dialogVisible"
    @close="handleCancel"
    width="80%">
    <div style="position: relative">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="公司信息" name="company">
          <Company ref="company" :editCompanyForm="editCompanyForm" :identity="identity" @clear="clearAll" @contact-updated="onContactUpdated"/>
        </el-tab-pane>
        <el-tab-pane label="合作意向" name="cooperation">
          <CooperationByWhiteList v-if="isSupplier && isByFeatureWhitelist" ref="cooperation" :editCooperationFrom="editCooperationFrom"/>
          <Cooperation v-if="isSupplier && !isByFeatureWhitelist" ref="cooperation" :editCooperationFrom="editCooperationFrom"/>
          <DistributorCooperation v-if="isDistributorMyCard"  ref="cooperation" :editCooperationFrom="editCooperationFrom" />
        </el-tab-pane>
      </el-tabs>
      <span class="tips" v-if="isSupplier">完善供销商名片信息，增加分销商合作机会</span>
      <span class="tips" v-if="isDistributorMyCard">完善分销商名片信息，增加供销商合作机会</span>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSure" v-loading="loading">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters as mapGettersVuex  } from "vuex";
import Company from './company.vue'
import Cooperation from './cooperation.vue'
import CooperationByWhiteList from './cooperationByWhiteList.vue'
import DistributorCooperation from "./distributorCooperation";
import { getEditBusinessCard, getEditCooperationIntention } from '@servers/commodity/index'
import { getScmCompanyConf, setScmCompanyConf } from '@/servers/prod/conf/index.js'
import { setMainCategoryList } from '@/servers/prod/center'
import {getEditDmsBusinessCard} from "@api/distributor";
import { CheckFeatureWhitelistPower } from '@/utils/powerConsts.js'

import Log from "@/components/prod/log";

export default {
  props: {
    identity: {
      type: String,
      default: 'supplier'
    },
    // editCompanyForm: {
    //   type: Object,
    //   default: ()=> {
    //     return {
    //       companyName: '',
    //       majorCategory: '',
    //       wx: '',
    //       phone: '',
    //       vipMark: false,
    //       majorCategoryName: '',
    //       distributionPlatform: [],
    //       majorPlatform: [],
    //       video: [],
    //       picture: [],
    //       summary: '',
    //     }
    //   }
    // },
    // editCooperationFrom: {
    //   type: Object,
    //   default: ()=> {
    //     return {
    //       cooperationMode: [], // 合作模式 1: 一件代发、 2:批量采购 - 可多选，逗号分隔
    //       deliveryTime: 1
    //     }
    //   }
    // }
  },
  data() {
    return{
      dialogVisible: false,
      activeName: 'company',
      editCompanyForm: {},
      editCooperationFrom: {},
      isClear: false,
      loading: false,
      scmCompanyConf: {},
    }
  },
  computed: {
    ...mapGettersVuex(['userBtnPowerConsts']),

    isSupplier() {
      // 供销商
      return this.identity === 'supplier'
    },
    isDistributorMyCard() {
      // 分销商名片
      return this.identity === 'myDistributor'
      },
    isByFeatureWhitelist () {
        return CheckFeatureWhitelistPower(this.userBtnPowerConsts.PROD_CENTER_BATCH_MODIFY_OPERATION)
    },
  },
  components: {
    Company,
    Cooperation,
    CooperationByWhiteList,
    DistributorCooperation
  },
  methods: {
    clearAll(data) {
      this.isClear = data
    },
    onContactUpdated(contactData) {
      if (contactData.wx !== undefined) this.editCompanyForm.wx = contactData.wx;
      if (contactData.wxCode !== undefined) this.editCompanyForm.wxCode = contactData.wxCode;
      if (contactData.phone !== undefined) this.editCompanyForm.phone = contactData.phone;
      this.$emit('contact-updated', contactData);
    },
    async method_open (editCompanyForm, editCooperationFrom) {
        if (this.isByFeatureWhitelist) {
            this.dialogVisible = true;
            this.editCompanyForm = {...editCompanyForm}
            this.editCooperationFrom = {...editCooperationFrom}
        } else {
            let data = await getScmCompanyConf();
            this.scmCompanyConf = data;
            this.editCompanyForm = { ...editCompanyForm };
            this.editCooperationFrom = {
                ...editCooperationFrom,
                supplyServiceCapability: data.supplyServiceCapability,
                supplyItemCapability: data.supplyItemCapability, 
            }
            this.dialogVisible = true;
        }
    },
    async handleSure() {
      this.loading = true;
      const cooperation_data = await this.$refs.cooperation.method_getFormData();
      const company_data = await this.$refs.company.method_getFormData();
      let company_fromData = {};
      let cooperation_fromData = {};

      if(this.activeName === 'cooperation') {
        if(!cooperation_data) {
          this.loading = false;
          return this.$message.error('合作意向存在未录入的必填项')
        }
        if(!company_data) {
          this.loading = false;
          return this.$message.error('公司信息存在未录入的必填项')
        }
      } else {
        if(!company_data) {
          this.loading = false;
          return this.$message.error('公司信息存在未录入的必填项')
        }
        if(!cooperation_data) {
          this.loading = false;
          return this.$message.error('合作意向存在未录入的必填项')
        }
      }
      company_fromData = {
        name: company_data.companyName,
        summary: company_data.summary,
        picture: company_data.picture.join(','),
        video: JSON.stringify(company_data.video),
        collaborationDesc:company_data.collaborationDesc,
        receiveAddressId:company_data.receiveAddressId,
      };
      cooperation_fromData = {...cooperation_data};

      let saveCooperationIntention = null;
      let saveBusinessCard = null;
      if (this.identity === 'myDistributor') {
        saveCooperationIntention = getEditCooperationIntention;
        saveBusinessCard = getEditDmsBusinessCard;
        company_fromData.showSupplier = company_data.showMainPlatform;
        company_fromData.collaborationDesc = company_data.collaborationDesc;
        company_fromData.receiveAddressId = company_data.receiveAddressId;
      } else {
        saveCooperationIntention = getEditCooperationIntention;
        saveBusinessCard = getEditBusinessCard;
        company_fromData.showDistributor = company_data.showMainPlatform;
      }
        let promise = null;
        if (this.isByFeatureWhitelist) {
            //白名单用户
            let scmCompanyConf = {
                ...this.scmCompanyConf,
                supplyServiceCapability: cooperation_fromData.supplyServiceCapability,
                supplyItemCapability: cooperation_fromData.supplyItemCapability,
            };
            delete cooperation_fromData.supplyServiceCapability;
            delete cooperation_fromData.supplyItemCapability;
            promise = [saveCooperationIntention(cooperation_fromData), saveBusinessCard(company_fromData), setScmCompanyConf(scmCompanyConf)];

        } else {
            promise = [saveCooperationIntention(cooperation_fromData), saveBusinessCard(company_fromData)];

        }

      if(this.isClear) {
        promise.push(setMainCategoryList([]))
      }
      Promise.all(promise).then(res=> {
        if(res) {
           this.$message.success('保存成功');
           this.loading = false;
           this.$emit('update', 'company');
           this.$emit('update-mainList')
           this.$emit('update', 'cooperation');
           this.handleCancel();
        }
      })
    },
    handleCancel() {
      this.dialogVisible =false;
      this.$emit('update-mainList')
      this.$refs.company?.method_reset();
      this.$refs.cooperation?.method_reset();
      this.isClear = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 12px;
}
</style>
